export function scrollToId(id) {
  const el = document.getElementById(id.replace("#", ""));
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
